// extracted by mini-css-extract-plugin
export var animationContainer = "_dc-0";
export var asteriskIcon = "_dc-8";
export var conversationLeftSection = "_dc-4";
export var conversationListItem = "_dc-3";
export var conversationMiddleSection = "_dc-5";
export var conversationRightSection = "_dc-6";
export var detailsContent = "_dc-1";
export var listContainer = "_dc-7";
export var modalContent = "_dc-2";